import { canv } from '@/canv/global.js'

export class shapeDisplay {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width - width/4 - width/8 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width/4 + (width  - width/4 - width/8)/ 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width * 7/8, y);
        canv.ctx.lineTo(x + width/4, y);
        canv.ctx.lineTo(x, y + height/2);
        canv.ctx.lineTo(x + width/4, y + height);
        canv.ctx.lineTo(x + width * 7/8, y + height);
        canv.ctx.ellipse(x + width * 7/8, y + height/2, width/8, height/2, 0, 1/2 * Math.PI, 3/2 * Math.PI, true);

    }

    getAvatar(color) {
        return `
        <svg width="80" height="74" viewBox="0 0 80 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.6162 0.499404C20.082 -0.369894 68.136 0.0613561 70.1234 0.546963C82.761 3.63484 83.8129 68.5326 70.1234 72.6557C68.1928 73.2371 22.3098 73.1152 17.8607 72.7072C17.6282 72.6858 17.4744 72.5399 17.3756 72.3284L0.206055 35.5774C0.0759811 35.299 0.0811386 34.9762 0.220055 34.7021L17.4695 0.66339L17.475 0.652471C17.5112 0.580648 17.5384 0.52684 17.6162 0.499404Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.59315 1.13576C8.0441 0.891403 22.3086 1.02311 22.9136 1.17093C26.8628 2.13589 27.1915 22.4164 22.9136 23.7049C22.336 23.8789 9.16955 23.8513 6.82786 23.7368C6.59469 23.7254 6.42355 23.5891 6.32474 23.3776L1.20605 12.4212C1.07598 12.1428 1.08114 11.82 1.22005 11.5459L6.41864 1.28735C6.45781 1.21006 6.5077 1.15015 6.59315 1.13576Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
